import { InnerContainer, StickyContainer } from './styled';
export function TableActionsContainer(props) {
    const { children, show = false } = props;
    return (<StickyContainer $show={show}>
      <InnerContainer>{children}</InnerContainer>
    </StickyContainer>);
}
